define( [
	"../Data"
], function( Data ) {
	"use strict";

	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/data/var/dataUser.js
// module id = 106
// module chunks = 0